import LogoDark from "../../assets/logos/inrev-logo-dark.svg";

export const AppLoading = () => (
	<div
		data-testid="app-loading"
		className="flex items-center justify-center w-[100vw] h-[100vh] bg-white"
	>
		<img src={LogoDark} alt="InRev Logo" className="w-[130px] animate-pulse" />
	</div>
);
